import * as React from "react";
import { forwardRef } from "react";
const SvgNoCard = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={32} height={20} viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<rect width={32} height={20} rx={4} fill="#B7BFC8" /><rect x={6} y={6} width={20} height={2} rx={1} fill="white" /></svg>;
const ForwardRef = forwardRef(SvgNoCard);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAzMiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iI0I3QkZDOCIvPgo8cmVjdCB4PSI2IiB5PSI2IiB3aWR0aD0iMjAiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";